export default "__VITE_ASSET__DNBnjXyq__"